import { createAsyncThunk, createSlice, EntityState } from '@reduxjs/toolkit';
import { fetchContentTags } from 'api/content-tag.service';
import { ContentTagSummaryModel, IncludeReadOnlyQuery } from 'types/entity';
import { contentTagAdapter } from './content-tag-read.adapter';

export const CONTENT_TAG_READ_STORE_NAME = 'contentTagRead';

export const loadContentTags = createAsyncThunk(
  `${CONTENT_TAG_READ_STORE_NAME}/load`,
  async (payload: {projectId: string, includeReadOnly: IncludeReadOnlyQuery}) => {
    const { projectId, includeReadOnly } = payload;
    return fetchContentTags(projectId, includeReadOnly);
  },
);

export type ContentTagReadState = EntityState<ContentTagSummaryModel> & {
  loaded: boolean
  error?: any
}

export const initialContentTagReadState: ContentTagReadState = contentTagAdapter.getInitialState({
  loaded: false,
  error: null,
});

export const contentTagReadSlice = createSlice({
  name: CONTENT_TAG_READ_STORE_NAME,
  initialState: initialContentTagReadState,
  // awaitでないAction系
  reducers: {
  },
  // awaitするAction系
  extraReducers: (builder) => {
    builder.addCase(loadContentTags.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(loadContentTags.fulfilled, (state, action) => {
      // 結果で全件洗い替えるため、setAllを使う
      contentTagAdapter.setAll(state, action.payload);
      state.loaded = true;
    });
    builder.addCase(loadContentTags.rejected, (state, action) => {
      state.error = action.payload;
      state.loaded = true;
    });
  },
});

// Action creators are generated for each case reducer function
export const contentTagReadActions = {
  ...contentTagReadSlice.actions,
  loadContentTags,
};

export default contentTagReadSlice.reducer;
